const getRecursive = (obj, props) => {
  const [prop, ...restProps] = props;

  if (restProps.length >= 1) {
    return getRecursive(obj[prop], restProps);
  }

  return obj[prop];
};

/**
 *
 * @param {String} path
 * @returns {any|null} returns null in case portal is not defined.
 */
export const getPortalVariables = path => {
  if (typeof window.manomano?.portal === 'undefined') return null;

  if (path.includes('.')) {
    return getRecursive(window.manomano.portal, path.split('.'));
  }

  return window.manomano.portal[path];
};
